import type { FormDataMap, FormElementConfig, FormFieldValue, FormValues } from './form-builder.types';

export interface FieldState {
    readonly value: FormFieldValue;
    readonly error: string | undefined;
    readonly isTouched: boolean;
    readonly disabled: boolean;
    readonly hidden: boolean;
    readonly helperText: string | undefined;
    readonly required: boolean;
    readonly rendered: boolean;
    readonly validating: boolean;
}

export interface FormStoreConfig {
    readonly id: string;
    readonly elements: readonly FormElementConfig[];
    readonly defaultValues?: FormValues | undefined;
    readonly data?: FormDataMap | undefined;
}

export const DEFAULT_FIELD_STATE: FieldState = {
    value: '',
    error: undefined,
    isTouched: false,
    disabled: false,
    hidden: false,
    helperText: undefined,
    required: false,
    rendered: true,
    validating: false,
};
